module.exports = __webpack_public_path__ + "static/domonda-c37650d8b5c5f7c7259c9ac26e67bf47.png";